import { useMemo } from "react";
import {
  exteriorDamageLocationKeys,
  hardwareDamageLocationKeys,
  interiorDamageLocationKeys,
} from "types/damages";
import DamageTable from "./damage-table/DamageTable";
import useContent from "@@hooks/useContent";

type DamageMatrixTabProps = {
  activeTab: string;
};

const DamageMatrixTab: React.FC<DamageMatrixTabProps> = (props) => {
  const { activeTab } = props;
  const {
    content: { itemReview: content },
  } = useContent();

  const damageHeaders = useMemo(() => {
    switch (activeTab) {
      case "exterior":
      case "interior":
        return [
          {
            key: "parts",
            label: content.damageCategory.parts,
            width: 108,
          },
          {
            key: "stained",
            label: content.damageCategory.stained,
          },
          {
            key: "otherDamages",
            label: content.damageCategory.otherDamages,
          },
        ];
      case "hardware":
        return [
          {
            key: "parts",
            label: content.damageCategory.parts,
          },
          {
            key: "damages",
            label: content.damageCategory.damages,
          },
        ];
      default:
        return [];
    }
  }, [activeTab, content]);

  const [damageKeys] = useMemo(() => {
    switch (activeTab) {
      case "exterior":
        return [exteriorDamageLocationKeys];
      case "hardware":
        return [hardwareDamageLocationKeys];
      case "interior":
        return [interiorDamageLocationKeys];
      default:
        return [exteriorDamageLocationKeys];
    }
  }, [activeTab]);

  return (
    <DamageTable
      damageKeys={damageKeys}
      headers={damageHeaders}
      showGenericDamages={activeTab === "exterior"}
      tab={activeTab}
    />
  );
};

export default DamageMatrixTab;
